import axios from "axios";
import {
  EMPLOYER_BUILD_REQUEST,
  EMPLOYER_BUILD_SUCCESS,
  EMPLOYER_BUILD_FAIL,
  EMPLOYER_BUILD_RESET,
  EMPLOYER_BUILDLIST_REQUEST,
  EMPLOYER_BUILDLIST_SUCCESS,
  EMPLOYER_BUILDLIST_FAIL,
  EMPLOYER_ALLBUILDLIST_REQUEST,
  EMPLOYER_ALLBUILDLIST_SUCCESS,
  EMPLOYER_ALLBUILDLIST_FAIL,
  EMPLOYER_BUILDDETAIL_REQUEST,
  EMPLOYER_BUILDDETAIL_SUCCESS,
  EMPLOYER_BUILDDETAIL_FAIL,
  EMPLOYER_BUILDUPDATE_REQUEST,
  EMPLOYER_BUILDUPDATE_SUCCESS,
  EMPLOYER_BUILDUPDATE_FAIL,
  EMPLOYER_HIRE_REQUEST,
  EMPLOYER_HIRE_SUCCESS,
  EMPLOYER_HIRE_FAIL,
  EMPLOYER_HIRE_RESET,
  EMPLOYER_HIRELIST_REQUEST,
  EMPLOYER_HIRELIST_SUCCESS,
  EMPLOYER_HIRELIST_FAIL,
  EMPLOYER_ALLHIRELIST_REQUEST,
  EMPLOYER_ALLHIRELIST_SUCCESS,
  EMPLOYER_ALLHIRELIST_FAIL,
} from "../constants/employerConstants";
import Api from "../Api";

export const listBuildEmployer = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYER_BUILDLIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/employers/build/user`, config);
    dispatch({
      type: EMPLOYER_BUILDLIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: EMPLOYER_BUILDLIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const listAllBuildEmployer = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYER_ALLBUILDLIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/employers/build`, config);
    dispatch({
      type: EMPLOYER_ALLBUILDLIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: EMPLOYER_ALLBUILDLIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const detailBuildEmployer = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYER_BUILDDETAIL_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/employers/build/${id}`, config);
    dispatch({
      type: EMPLOYER_BUILDDETAIL_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: EMPLOYER_BUILDDETAIL_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const updateBuildEmployer = (
  title,
  details,
  skill,
  cloudList,
  budget,
  history,
  id
) => async (dispatch, getState) => {
  let file = cloudList;  try {
    dispatch({
      type: EMPLOYER_BUILDUPDATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.put(
      `${Api}/api/employers/build/edit/${id}`,
      { title, details, skill, file, budget },
      config
    );

    dispatch({
      type: EMPLOYER_BUILDUPDATE_SUCCESS,
      payload: res.data,
    });

    if (history.location.pathname.indexOf("admin")) {
      history.push(`/admin/job/${id}`);
    } else {
      history.push(`/employer/job/${id}`);
    }
  } catch (error) {
    dispatch({
      type: EMPLOYER_BUILDUPDATE_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const buildEmployer = (
  title,
  details,
  skill,
  file,
  budget,
  history
) => async (dispatch, getState) => {  try {
    dispatch({
      type: EMPLOYER_BUILD_REQUEST,
    });

    let checkAdmin = history.location.pathname.indexOf("admin");

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.post(
      `${Api}/api/employers/build`,
      { title, details, skill, file, budget },
      config
    );

    dispatch({
      type: EMPLOYER_BUILD_SUCCESS,
      payload: res.data,
    });

    if (checkAdmin !== -1) {
      history.push("/admin/jobs");
    } else {
      history.push("/employer/booking");
    }
  } catch (error) {
    dispatch({
      type: EMPLOYER_BUILD_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const listHireEmployer = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYER_HIRELIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/employers/hire/user`, config);
    dispatch({
      type: EMPLOYER_HIRELIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: EMPLOYER_HIRELIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const listAllHireEmployer = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYER_ALLHIRELIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/employers/hire`, config);
    dispatch({
      type: EMPLOYER_ALLHIRELIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: EMPLOYER_ALLHIRELIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const hireEmployer = (
  company,
  country,
  employeesnumber,
  skillrequest,
  otherdetails,
  history
) => async (dispatch, getState) => {
  try {
    dispatch({
      type: EMPLOYER_HIRE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const res = await axios.post(
      `${Api}/api/employers/hire`,
      { company, country, employeesnumber, skillrequest, otherdetails },
      config
    );

    dispatch({
      type: EMPLOYER_HIRE_SUCCESS,
      payload: res.data,
    });

    history.push("/employer/dashboard");
  } catch (error) {
    dispatch({
      type: EMPLOYER_HIRE_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};
